import React from "react";
import PropTypes from "prop-types";
import Icon from "../Icon";

const AddressField = ({
  className,
  addressText,
  hasError = false,
  errorMessage = "Please enter a valid address",
  onChangeHandler,
  placeholder,
  disabled,
}) => {
  return (
    <div className={className}>
      <textarea
        className={hasError ? "invalid" : "valid"}
        rows="7"
        cols="50"
        spellCheck="false"
        value={addressText}
        onChange={onChangeHandler}
        disabled={disabled}
        placeholder={placeholder}
      ></textarea>
      {hasError && (
        <div className="error">
          <Icon type="danger" />
          {errorMessage}
        </div>
      )}
    </div>
  );
};

AddressField.propTypes = {
  className: PropTypes.string,
  addressText: PropTypes.string,
  hasError: PropTypes.bool,
  errorMessage: PropTypes.string,
  onChangeHandler: PropTypes.func,
};

export default AddressField;
